import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { SystemDataType } from "../../../system/systemEdit/SystemEdit.types.ts";
import { dataTypeOptions } from "../../../system/systemEnumOptions.ts";

export interface SystemDataTypesFieldProps {
    dataTypes: Array<SystemDataType>;
    onChange: (dataTypes: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemDataTypesField(props: SystemDataTypesFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalMultiSelect
            options={dataTypeOptions(translateString)}
            chosenOptions={props.dataTypes.map((x) => x.toString())}
            onChange={props.readOnly ? () => {} : (types) => props.onChange(types)}
            placeholder={translateString("dataType")}
            label={translateString("dataType")}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={translateString("dataTypeTooltip")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemDataTypesField;
